<template>
  <div>
    <ClientOnly>
      <div class="relative">
        <swiper-container
          ref="containerRef"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }"
          :a11y="{
            enabled: false,
          }"
          :loop="true"
          :simulate-touch="false"
          @swiperinit="onSwiperInit"
          @swiperslidechange="onSlideChange"
          @swiperautoplaytimeleft="onAutoplayTimeLeft"
        >
          <swiper-slide v-for="(item, index) in banners" :key="hash(item)">
            <AreaHomeBannersItem :slide-index="index" :banner-data="item" />
          </swiper-slide>
        </swiper-container>

        <div
          v-if="banners.length > 1"
          class="absolute bottom-0 left-0 z-10 w-full"
        >
          <div
            class="container-wrap flex items-center justify-center pb-5 tablet:justify-end"
          >
            <button
              class="mx-2 flex h-10 w-10 items-center justify-center rounded-full bg-white text-blue-400 shadow-normal shadow-gray-400"
              title="Previous Banner"
              @click="handlePrev"
            >
              <IconCaret direction="left" />
            </button>
            <template v-if="isDesktop">
              <AreaHomeBannersCircleButton
                v-for="(item, index) in banners"
                :key="hash(item)"
                :is-active="swiperIndex === index"
                :swiper-progress="swiperProgress"
                :img-url="item.thumbnail"
                :title="item.title"
                @click="handleClick(index)"
              />
            </template>
            <button
              class="mx-2 flex h-10 w-10 items-center justify-center rounded-full bg-white text-blue-400 shadow-normal shadow-gray-400"
              title="Next Banner"
              @click="handleNext"
            >
              <IconCaret direction="right" />
            </button>
          </div>
        </div>
      </div>
    </ClientOnly>

    <!-- For SEO -->
    <ul v-show="!isInitialized">
      <li
        v-for="(item, index) in banners"
        v-show="index === 0"
        :key="hash(item)"
      >
        <AreaHomeBannersItem :slide-index="index" :banner-data="item" />
      </li>
    </ul>
  </div>
</template>

<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
  import hash from 'object-hash';

  const { isDesktop } = useScreen();

  const homeStore = useHomeStore();
  const { banners } = storeToRefs(homeStore);

  const containerRef = ref<null>(null);
  const swiperIndex = ref<number>(0);
  const swiperProgress = ref<number>(0);
  const swiperProgressGate = ref<boolean>(false);
  const isInitialized = ref<boolean>(false);

  const swiper = useSwiper(containerRef);

  const onSwiperInit = (event: CustomEvent): void => {
    const swiperInstance = event.detail[0];
    swiperIndex.value = swiperInstance.realIndex;

    nextTick(() => {
      isInitialized.value = true;
    });
  };

  const onSlideChange = (event: CustomEvent): void => {
    const swiperInstance = event.detail[0];
    swiperIndex.value = swiperInstance.realIndex;
  };

  const onAutoplayTimeLeft = (event: CustomEvent): void => {
    const [_swiper, _timeLeft, percentage] = event.detail;

    if (swiperProgressGate.value && percentage < 1) {
      swiperProgress.value = 0;
      return;
    }
    if (percentage === 1) {
      swiperProgressGate.value = false;
    }
    swiperProgress.value = 1 - percentage;
  };

  const handleClick = (index: number): void => {
    if (swiper.instance.value) {
      swiper.instance.value.slideToLoop(index);
      swiperProgressGate.value = true;
    }
  };

  const handlePrev = (): void => {
    swiper.prev();
  };

  const handleNext = (): void => {
    swiper.next();
  };
</script>
